const re = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i;

export function isEmailValid(str) {
    return re.test(str);
}
